import { post } from "@/services/axiosUitils";

const basePath = "/pts_app/employee-invite-codes";

interface SignupEmailCheckParams {
  email: string;
  refer_code?: string;
}

interface SignupEmailCheckResponse {
  success?: {
    code?: string;
    message?: string;
  };
  data?: {
    email?: string;
    is_active: boolean;
    message?: string;
  };
  // Fallback for direct response structure
  is_active?: boolean;
  message?: string;
}

class PtsEmployeeInviteService {
  verifyInviteCode = async (inviteCode: string): Promise<any> => {
    if (!inviteCode) {
      throw new Error("Invite code is required");
    }
    return await post(`${basePath}/verify/`, {
      invite_code: inviteCode,
    });
  };

  bindEmployee = async (employee: string, user_id: string): Promise<any> => {
    if (!employee || !user_id) {
      throw new Error("Employee and user ID are required");
    }
    return await post(`${basePath}/bind-employee/`, { employee, user_id });
  };

  /**
   * Check if email is active for signup (works with or without refer code)
   * Calls: /pts_app/signup-email-check/ with email and optional refer_code
   * @param params - Query parameters
   * @param params.email - Email address to check
   * @param params.refer_code - Optional refer code from invite
   * @returns Response with is_active status
   */
  checkSignupEmail = async (
    params: SignupEmailCheckParams
  ): Promise<SignupEmailCheckResponse> => {
    if (!params.email) {
      throw new Error("Email is required");
    }
    const body: { email: string; refer_code?: string } = {
      email: params.email,
    };
    if (params.refer_code) {
      body.refer_code = params.refer_code;
    }
    return await post<SignupEmailCheckResponse>(
      "/pts_app/signup-email-check/",
      body
    );
  };
}

export default new PtsEmployeeInviteService();
